import { ScopeId } from '@pubstack/common/src/scope'
import { FunctionComponent } from 'react'
import PureAdminScopeSiteSetupFlyout from './PureAdminScopeSiteSetupFlyout'
import { useSiteSetup } from './useSiteSetup'

type Props = {
  scopeId: ScopeId
  siteId: string
}

export const AdminScopeSiteSetupFlyout: FunctionComponent<Props> = ({ scopeId, siteId }) => {
  // Hooks
  const { site, isInitialLoading, isDownloading, mappingExportLoading, mappingExport, refetchMappingExport, downloadMappingExport } = useSiteSetup(scopeId, siteId)

  return (
    <PureAdminScopeSiteSetupFlyout
      isInitialLoading={isInitialLoading}
      isDownloading={isDownloading}
      site={site}
      mappingExportLoading={mappingExportLoading}
      mappingExport={mappingExport}
      onRefreshClick={refetchMappingExport}
      onDownloadClick={downloadMappingExport}
    />
  )
}
